import { render, staticRenderFns } from "./cadastrar-cartao.vue?vue&type=template&id=01ad74e6&"
import script from "./cadastrar-cartao.vue?vue&type=script&lang=js&"
export * from "./cadastrar-cartao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports